import { FunctionComponent, ReactNode } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import styles from "./navTabs.module.css";

type NavTab = {
  title: string;
  content: ReactNode;
};

type NavTabsProps = {
  tabs: NavTab[];
  selectedIndex?: number;
  onSelect?: (index: number) => void;
};

const NavTabs: FunctionComponent<NavTabsProps> = ({
  tabs,
  selectedIndex,
  onSelect,
}) => {
  const controlledProps =
    selectedIndex !== undefined
      ? {
          selectedIndex,
          onSelect: (index: number) => onSelect?.(index),
        }
      : {
          onSelect: (index: number) => {
            onSelect?.(index);
            return true;
          },
        };

  return (
    <Tabs {...controlledProps}>
      <TabList className={styles.tabList}>
        {tabs.map((tab, index) => (
          <Tab key={`${tab.title}-${index}`}>
            {tab.title}
          </Tab>
        ))}
      </TabList>

      {tabs.map((tab, index) => (
        <TabPanel key={`${tab.title}-${index}`}>
          {tab.content}
        </TabPanel>
      ))}
    </Tabs>
  );
};

export default NavTabs;